<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <strong>{{ title }}</strong>
          <span class="title-filter">Ngày nhận VB từ tòa: </span>
          <Calendar id="range" v-model="filterDate" selectionMode="range" :numberOfMonths="2" :manualInput="false" dateFormat="dd/mm/yy" :show-icon="true"/>
          <Button label="Tìm" @click="onEnter" class="p-button-success btn-enter-filter"/>
          <div class="box-selected-file" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.detail_document.export == true || this.$store.getters.role == 'admin'">
            <!-- <input type="file" name="exportFile" class="file" @change="onExportExcel"/>
            <span class="btn-span">Xuất Excel</span> -->
            <div class="opacity"/>
            <ExportExcel
              :fields="exportConfigs1.fields"
              :fetch="exportConfigs1.fetch"
              :colHeaderStyle="exportConfigs1.colHeaderStyle"
              :name="exportConfigs1.name"
              :subTitle="exportConfigs1.subTitle"
            >
              <span class="btn-span">Xuất Excel</span>
            </ExportExcel>
          </div>
          
          <div class="box-export-report" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.detail_document.export == true || this.$store.getters.role == 'admin'">
            <div class="opacity"/>
            <ExportExcel
              :fields="exportConfigs.fields"
              :fetch="exportConfigs.fetch"
              :colHeaderStyle="exportConfigs.colHeaderStyle"
              :name="exportConfigs.name"
              :subTitle="exportConfigs.subTitle"
              :renderBody="
                exportConfigs.renderBody ? exportConfigs.renderBody : undefined
              "
              :renderHeader="
                exportConfigs.renderHeader ? exportConfigs.renderHeader : undefined
              "
            >
              <span class="btn-span">In biên bản giao nhận</span>
            </ExportExcel>
          </div>
          
        </div>
        
        <DataTable
          :value="listData"
          class="p-datatable-responsive"
          dataKey="id"
          :selection.sync="selectedRows"
          :paginator="pagination"
          :rows="paginationRows"
          :loading="loading"
          :filters="filters"
          :scrollable="(scrollHeight !== '' ? true : false) "
          :scrollHeight="scrollHeight"
          :autoLayout="true"
          :key="componentKey"
          :rowsPerPageOptions="rowsPerPageOptions"
          currentPageReportTemplate="Tổng TĐV: {totalRecords}"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          @filter="onFilter"
        >
          <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
          <Column 
            v-for="c in dataModel.getDisplayFields()"
            :key="c.key"
            :field="getField(c)"
            :header="getLabel(c)"
            :filterMatchMode="getFilterMatch(c)"
            :sortable="getSortable(c)"
            :bodyClass="(c.class ? 'txt-' + c.class : '')"
            :bodyStyle="getHeaderStyle(c)"
            :headerStyle="getHeaderStyle(c)"
            :headerClass="(c.class ? 'txt-' + c.class : '')"
          >
            <template #body="slotProps">
              <img
                v-if="getType(c) == 'Image'"
                :src="getData(c, slotProps.data)"
                style="width: 40px; heigth: 40px"
              />
              <div
                v-else-if="c.type == 'Text'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>
              <div
                v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
                v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"
              ></div>

              <Checkbox
                v-else-if="getType(c) == 'Checkbox'"
                v-model="slotProps.data[slotProps.column.field]"
                :binary="true"
                @change="onInputChange($event, slotProps.data, c)"
              />
              <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
            </template>
            <template v-if="c.filter" #filter>
              <InputText
                v-if="c.filter.type == 'input'"
                type="text"
                v-model="filters[c.key]"
                class="p-column-filter"
                :placeholder="getFilterPlaceHolder(c)"
              />
              <Dropdown
                :key="countDropdown"
                v-if="c.filter.type == 'select'"
                v-model="filters[getField(c)]"
                :options="getFilterOptions(c.key)"
                :optionLabel="c.filter.optionLabel"
                :optionValue="c.filter.optionKey"
                :placeholder="getFilterPlaceHolder(c)"
                class="p-column-filter"
                :showClear="true"
                appendTo="body"
              >
                <template #option="slotProps">
                  <div class="p-clearfix">
                    <span
                      :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                      >{{ slotProps.option[c.filter.optionLabel] }}</span
                    >
                  </div>
                </template>
              </Dropdown>
              <Calendar 
                v-if="c.filter.type == 'DateRange'"
                :showOnFocus="false" 
                :monthNavigator="true" 
                :yearNavigator="true" 
                yearRange="2000:2030" 
                dateFormat="yy-mm-dd" 
                id="date_from" 
                v-model="filters[getField(c)]" 
                class="p-column-filter"
                :showIcon="true" 
                selectionMode="range"
                appendTo="body"
                :showClear="true"
                @date-select="select_date($event,getField(c))"
                :manualInput="false"
                />
            </template>
          </Column>
          <template #empty>
            {{ $t('datatable.empty') }}
          </template>
          <template #loading>
            {{ $t('datatable.loading') }}
          </template>
          <template #footer>
            Tổng văn bản nhận: {{ totalDoc }}
            <span style="margin-left: 30px"></span>
            Tổng văn bản đã hoàn thành: {{ totalComplete }}
            <span style="margin-left: 30px"></span>
            Tổng văn bản tồn: {{ totalRemain }}
          </template>
        </DataTable>

        

        <Dialog
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xóa <strong>{{this.deleteName}}</strong>
          <template
            #footer
          >
            <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button
              label="Hủy"
              @click="showDeleteDialog = false"
              icon="pi pi-times"
              class="p-button-warning"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import gql from "graphql-tag";
import moment from "moment-timezone";
// import XLSX from "xlsx"
import graphql from '../common/graphql'
export default {
  components: {
  },
  data() {
    return {
      filterOptions: {},
      listData: [],
      options: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      totalDoc: 0,
      totalRemain: 0,
      totalComplete: 0,
      // 
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: 10, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      selectedRows: null,
      filterDate: null,
      dateFrom: null,
      dateTo: null,
      // EXPORT
      exportConfigs: {
        sheetInfo: 'CÔNG TY CỔ PHẦN ENGMA',
        header: 'DANH SÁCH VĂN BẢN',
        subTitle: (data) => {
          let subTitle = '';
          let dateFrom = '...';
          let dateEnd = '...';
          console.log(data);
          if (this.filterDate !== null) {
            dateFrom = moment(this.filterDate[0]).format('DD/MM/YYYY');
            dateEnd = this.filterDate[1] !== null ? moment(this.filterDate[1]).format('DD/MM/YYYY') : '...';
          }

          subTitle = `Từ ngày ${dateFrom} đến ngày ${dateEnd}`;
          return subTitle;
        },
        colHeaderStyle: 'background-color:#bfbfbf; font-weight: bold; border: solid 1px #fffff',
        // fields: {
        //   'STT': 'stt',
        //   'MÃ SỐ': 'code_system',
        //   'MÃ VĂN BẢN TÒA': 'code_court',
        //   'SỐ QĐ THA': 'number_decision',
        //   'NỘI DUNG VB': 'content_document',
        //   'NGÀY BAN HÀNH': {
        //     field: 'date_issued',
        //     callback: (value) => {
        //       if (value)
        //         return moment
        //           .utc(value)
        //           .clone()
        //           .tz('Asia/Ho_Chi_Minh')
        //           .format('DD/MM/YYYY');
        //     },
        //   },
        //   'NGÀY MỜI': {
        //     field: 'date_invite',
        //     callback: (value) => {
        //       if (value)
        //         return moment
        //           .utc(value)
        //           .clone()
        //           .tz('Asia/Ho_Chi_Minh')
        //           .format('DD/MM/YYYY');
        //     },
        //   },
        //   'TÊN': 'name_litigant',
        //   'ĐỊA CHỈ': 'address',
        //   'PHƯỜNG/ XÃ': {
        //     callback: (row) => {
        //       return row.ward.name
        //     }
        //   },
        //   'QUẬN/ HUYỆN': {
        //     callback: (row) => {
        //       return row.district.name
        //     }
        //   },
        //   'TP/ TỈNH': {
        //     callback: (row) => {
        //       return row.state.name
        //     }
        //   },
        //   'NGƯỜI KÝ': 'signer',
        //   'MÃ CƠ QUAN': 'code_agency',
        //   'NGÀY NHẬN TỪ TÒA': {
        //     field: 'date_receipt_court',
        //     callback: (value) => {
        //       if (value)
        //         return moment
        //           .utc(value)
        //           .clone()
        //           .tz('Asia/Ho_Chi_Minh')
        //           .format('DD/MM/YYYY');
        //     },
        //   },
        //   'GẤP': {
        //     callback: (row) => {
        //       if (row.is_urgent) {
        //         return 'Gấp';
        //       } else {
        //         return '';
        //       }
        //     }
        //   },
        //   'LOẠI': 'type_document',
        // },
        fetch: async () => {
          let data = [];
          let arrIDs = []
          if (this.selectedRows && this.selectedRows.length > 0) {
            for (let i = 0; i < this.selectedRows.length; i++) {
              arrIDs.push(this.selectedRows[i].id)
            }
          }
          if (arrIDs.length > 0) {
            let variables = {
              where: {
                id: {'_in': arrIDs}
              },
              orderBy: {id: 'asc'}
            }
            if (this.filterDate) {
              let date1 = new Date(this.filterDate[0]).toISOString()
              date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
              let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : '';
              date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
              Object.assign(variables, {date_from: date1, date_to: date2})
            }
            await this.$apollo.query({
              query: gql(graphql.GET_STATEMENT_DETAIL),
              variables: variables,
              fetchPolicy: "no-cache"
            }).then(async (resData) => {
              // console.log("=============fetch data", resData)
              let lstdata = resData.data.users;
              for (let i = 0; i < lstdata.length; i++) {
                let user_info = {}
                let stt = 0;
                if (lstdata[i].view_tdv_total_doc_waiting_no_scan.length > 0) {
                  user_info.fullname = lstdata[i].fullname;
                  let documents = lstdata[i].view_tdv_total_doc_waiting_no_scan
                  for (let j = 0; j < documents.length; j++) {
                    stt += 1;
                    documents[j].document.fullname = lstdata[i].fullname;
                    documents[j].document.stt = stt;
                  }
                  let obj = [
                    user_info,
                    documents
                  ]
                  data.push(obj);
                } else {
                  user_info.fullname = lstdata[i].fullname;
                  let obj = [
                    user_info,
                    []
                  ]
                  data.push(obj);
                }
              }
            }).catch((error) => {
              console.log(error);
            });
            // console.log("Fecth return", data)
            if (data.length > 0) {
              this.selectedRows = null;
              this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất file excel thành công', life: 3000 })
              return data;
            } else {
              this.selectedRows = null;
              this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Không có văn bản giao nhận', life: 3000 })
              return data;
            }
          } else {
            this.selectedRows = null;
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng chọn ít nhất 1 Tống đạt viên', life: 3000 })
            return data;
          }
          
        },
        name: 'In biên bản giao nhận.xls',
        renderHeader: () => {
          return '';
        },
        renderBody: (data) => {
          // console.log('================', data);
          let body = '';
          let headerStyle = `background-color:#bfbfbf; font-weight: bold;`;
          let tHeader = `<tr>
            <th style="${headerStyle}">STT</th>
            <th style="${headerStyle}">MÃ SỐ</th>
            <th style="${headerStyle}">MÃ VĂN BẢN TÒA</th>
            <th style="${headerStyle}">SỐ QD THA</th>
            <th style="${headerStyle}">NỘI DUNG VĂN BẢN</th>
            <th style="${headerStyle}">NGÀY BAN HÀNH</th>
            <th style="${headerStyle}">NGÀY MỜI</th>
            <th style="${headerStyle}">TÊN</th>
            <th style="${headerStyle}">ĐỊA CHỈ</th>
            <th style="${headerStyle}">PHƯỜNG/ XÃ</th>
            <th style="${headerStyle}">QUẬN/ HUYỆN</th>
            <th style="${headerStyle}">TP/ TỈNH</th>
            <th style="${headerStyle}">NGƯỜI KÝ</th>
            <th style="${headerStyle}">MÃ CƠ QUAN</th>
            <th style="${headerStyle}">NGÀY NHẬN TỪ TÒA</th>
            <th style="${headerStyle}">GẤP</th>
            <th style="${headerStyle}">LOẠI</th>
          </tr>`;
          for (let i = 0; i < data.length; i++) {
            const d = data[i];
            let uinfo = d[0];
            let vbinfo = d[1];
            let subTable = `<tr><td colspan="4">Nhân viên: ${uinfo.fullname}</td></tr>
            ${tHeader}`;
            for (let i = 0; i < vbinfo.length; i++) {
              // console.log(vbinfo);
              const k = vbinfo[i].document;
              subTable += `<tr>
                <td>${k.stt}</td>
                <td>${(k.code_system) ? k.code_system:''}</td>
                <td>${(k.code_court) ? k.code_court:''}</td>
                <td>${(k.number_decision) ? k.number_decision:''}</td>
                <td>${(k.content_document) ? k.content_document:''}</td>
                <td>${(k.date_issued) ?  moment.utc(new Date(k.date_issued)).clone().tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY'):''}</td>
                <td>${(k.date_invite) ? moment.utc(new Date(k.date_invite)).clone().tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY'):''}</td>
                <td>${(k.name_litigant) ? k.name_litigant:''}</td>
                <td>${(k.address) ? k.address:''}</td>
                <td>${(k.ward) ? k.ward.name:''}</td>
                <td>${(k.district) ? k.district.name:''}</td>
                <td>${(k.state) ? k.state.name:''}</td>
                <td>${(k.signer) ? k.signer:''}</td>
                <td>${(k.code_agency) ? k.code_agency:''}</td>
                <td>${moment.utc(new Date(k.date_receipt_court)).clone().tz('Asia/Ho_Chi_Minh').format('DD/MM/YYYY')}</td>
                <td>${k.is_urgent && 'Gấp' || ''}</td>
                <td>${(k.type_document) ? k.type_document:''}</td>
              </tr>`;
            }
            body += subTable + '<tr></tr>';
          }
          return body;
        },
      },
      exportConfigs1: {
        sheetInfo: 'CÔNG TY CỔ PHẦN ENGMA',
        header: 'DANH SÁCH VĂN BẢN',
        subTitle: () => {
          let subTitle = '';
          let dateFrom = '...';
          let dateEnd = '...';
          // console.log(data);
          if (this.filterDate !== null) {
            dateFrom = moment(this.filterDate[0]).format('DD/MM/YYYY');
            dateEnd = this.filterDate[1] !== null ? moment(this.filterDate[1]).format('DD/MM/YYYY') : '...';
          }

          subTitle = `Từ ngày ${dateFrom} đến ngày ${dateEnd}`;
          return subTitle;
        },
        colHeaderStyle: 'background-color:#bfbfbf; font-weight: bold; border: solid 1px #fffff',
        fields: {
          'STT  ': 'stt',
          'HỌ TÊN': 'fullname',
          'TỔNG VĂN BẢN NHẬN': {
            callback: (row) => {
              return row.totalConfirmed
            }
          },
          'VB THƯỜNG (LOẠI 1+2)': {
            callback: (row) => {
              return row.totalNormal
            }
          },
          'VB KHÔNG THÀNH NIÊM YẾT (LOẠI 1+2)': {
            callback: (row) => {
              return row.totalNormalKT + row.totalNormalNY
            }
          },
          'VB LOẠI 3': {
            callback: (row) => {
              return row.totalType3
            },
          },
          'VĂN BẢN TRẢ TÒA (LOẠI 4)': {
            callback: (row) => {
              return row.totalType4
            },
          },
          'VĂN BẢN LOẠI 5': {
            callback: (row) => {
              return row.totalType5
            }
          },
          'VĂN BẢN TỒN': {
            callback: (row) => {
              return row.totalRemain
            }
          },
          'VĂN BẢN MỚI': {
            callback: (row) => {
              return row.totalNew
            }
          },
          'GHI CHÚ': 'note',
        },
        fetch: async () => {
          let data = [];
          let arrIDs = []
          if (this.selectedRows && this.selectedRows.length > 0) {
            for (let i = 0; i < this.selectedRows.length; i++) {
              arrIDs.push(this.selectedRows[i].id)
            }
          }
          if (arrIDs.length > 0) {
            let variables = {
              where: {
                id: {'_in': arrIDs}
              },
              orderBy: {id: 'asc'}
            }
            if (this.filterDate) {
              let date1 = new Date(this.filterDate[0]).toISOString()
              date1 = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
              let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : '';
              date2 = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
              Object.assign(variables, {date_from: date1, date_to: date2})
            }
            await this.$apollo.query({
              query: gql(graphql.GET_STATEMENT_DETAIL),
              variables: variables,
              fetchPolicy: "no-cache"
            }).then(async (resData) => {
              // console.log("=============fetch data", resData)
              let lstdata = resData.data.users;
              // var totalRemain = 0;
              // var totalConfirmed = 0;
              // var totalNew = 0;
              // var totalNormalKT = 0;
              // var totalNormalNY = 0;
              // var totalType3 = 0;
              // var totalType4 = 0;
              // var totalType5 = 0;
              for (let i = 0; i < lstdata.length; i++) {
                lstdata[i].totalConfirmed = lstdata[i].view_tdv_total_doc_confirmed_aggregate.aggregate.count;
                lstdata[i].totalNew = lstdata[i].view_tdv_total_doc_waiting_no_scan_aggregate.aggregate.count;
                lstdata[i].totalNormal = lstdata[i].view_tdv_total_doc_normal_tt_gn_nt3_aggregate.aggregate.count;
                lstdata[i].totalNormalKT = lstdata[i].view_tdv_total_doc_normal_kt_aggregate.aggregate.count;
                lstdata[i].totalNormalNY = lstdata[i].view_tdv_total_doc_normal_ny_aggregate.aggregate.count;
                lstdata[i].totalType3 = lstdata[i].view_tdv_total_doc_type3_aggregate.aggregate.count;
                lstdata[i].totalType4 = lstdata[i].view_tdv_total_doc_type4_aggregate.aggregate.count;
                lstdata[i].totalType5 = lstdata[i].view_tdv_total_doc_type5_aggregate.aggregate.count;
                // lstdata[i].totalRemain = lstdata[i].totalConfirmed - (lstdata[i].totalNew + lstdata[i].totalNormal + lstdata[i].totalNormalKT + lstdata[i].totalNormalNY + lstdata[i].totalType3 + lstdata[i].totalType4 + lstdata[i].totalType5)
                lstdata[i].totalRemain = lstdata[i].view_tdv_total_doc_remaining_aggregate.aggregate.count;
                lstdata[i].stt = i + 1;
                data.push(lstdata[i]);
              }
            }).catch((error) => {
              console.log(error);
            });
            // console.log("Fecth return", data)
            if (data.length > 0) {
              this.selectedRows = null;
              this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất file excel thành công', life: 3000 })
              return data;
            } else {
              this.selectedRows = null;
              this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Không có văn bản giao nhận', life: 3000 })
              return data;
            }
          } else {
            this.selectedRows = null;
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng chọn ít nhất 1 Tống đạt viên', life: 3000 })
            return data;
          }
          
        },
        name: 'Xuất Excel.xls',
      },
    }
  },
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel('statement_detail')
    this.title = this.dataModel.label
    this.$store.commit('setLoading', true);
    // if(this.$route.params.reload) {
    //   window.location.reload();
    // }
    this.loading = false;
    this.countDropdown++;
    // this.$apollo.queries.listData.refresh();
    await this.onCreated();
    this.callbackOptions();
  },
  mouted() {
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    onFilter(e){
      /*console.log("eeeeeeeeeeeeeeeeeeeeee:",e);*/
      if (e.filteredValue){
        var listData = e.filteredValue
        this.totalDoc = 0;
        this.totalComplete = 0;
        this.totalRemain = 0;
          for (let i = 0; i < listData.length; i++) {
            this.totalDoc += listData[i].view_tdv_total_doc_confirmed_aggregate.aggregate.count;
            this.totalComplete += listData[i].view_tdv_total_doc_complete_aggregate.aggregate.count;
            // let confirmed = this.listData[i].view_tdv_total_doc_confirmed_aggregate.aggregate.count;
            // let noScan = this.listData[i].view_tdv_total_doc_waiting_no_scan_aggregate.aggregate.count;
            // let normalKT = this.listData[i].view_tdv_total_doc_normal_kt_aggregate.aggregate.count;
            // let normalNY = this.listData[i].view_tdv_total_doc_normal_ny_aggregate.aggregate.count;
            // let normalNT3 = this.listData[i].view_tdv_total_doc_normal_tt_gn_nt3_aggregate.aggregate.count;
            // let normalT3 = this.listData[i].view_tdv_total_doc_type3_aggregate.aggregate.count;
            // let normalT4 = this.listData[i].view_tdv_total_doc_type4_aggregate.aggregate.count;
            // let normalT5 = this.listData[i].view_tdv_total_doc_type5_aggregate.aggregate.count;
            // this.totalRemain += confirmed - (noScan + normalKT + normalNY + normalNT3 + normalT3 + normalT4 + normalT5)
            this.totalRemain += listData[i].view_tdv_total_doc_remaining_aggregate.aggregate.count;
          }
      }

    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields()
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_status = {}
          var tableName = element.models.tableName
          if (tableName == 'area'){
            where_status.deleted = {_eq: false};
          }
          var {data} = await this.$apollo.query({
            query: DataServices.getList(tableName, {"fields" : attributes.join(',')}),
            variables: {where_key : where_status}
          })
         /* console.log("datadatadatadata:",data);
          console.log("datadatadatadata:",element.models.tableName);*/
          if (data) {
            /*console.log("1111111111111111111111:",attributes[1]);*/
            var result = data[Object.keys(data)];
            /*console.log("222222222222222:",attributes[0]);*/
            if (result) {
              for (let index = 0; index < result.length; index++) {
                const ele = result[index];
                optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
              }
            }
          }
          /*console.log("elementelementelementelement:",element.key);
          console.log("datadatadatadata:",optionsData);*/
          this.options[element.key] = optionsData;
          /*console.log("datadatadatadata:",optionsData);
          console.log("element.key:",element.key);*/
        }
        this.componentKey++;
      }
    },
    async onCreated() {
      if (this.filterDate !== null) {
        let date1 = new Date(this.filterDate[0]).toISOString()
        this.dateFrom = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1;
        this.dateTo = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
      }
      await this.$apollo.query({
        query: gql(graphql.GET_STATEMENT_DETAIL),
        variables: {
          where: {
            users_account: {
              role: {'_eq': "tdv"},
              deleted: {'_eq': false}
            },
            deleted: {'_eq': false},
            _or:[{view_tdv_total_doc_confirmed: {doc_id: {_gt: 0}}},{view_tdv_total_doc_waiting_no_scan: {doc_id: {_gt: 0}}}]
            //view_tdv_total_doc_confirmed: {doc_id: {_gt: 0}},
            //view_tdv_total_doc_waiting_no_scan: {doc_id: {_gt: 0}}
          },
          date_from: this.dateFrom,
          date_to: this.dateTo,
          orderBy: {id: 'asc'}
        },
        fetchPolicy: 'network-only'
      }).then((res) => {
        // console.log(res)
        this.listData = [];
        this.totalDoc = 0;
        this.totalComplete = 0;
        this.totalRemain = 0;
        if (res && res.data && res.data.users.length > 0) {
          var list_data = [];
          var listDataRes = [...res.data.users];
          for (let i = 0; i < listDataRes.length; i++) {
            if (listDataRes[i].view_tdv_total_doc_confirmed_aggregate.aggregate.count >0 || listDataRes[i].view_tdv_total_doc_waiting_no_scan_aggregate.aggregate.count > 0) {
              list_data.push(listDataRes[i]);
              this.totalDoc += listDataRes[i].view_tdv_total_doc_confirmed_aggregate.aggregate.count;
              this.totalComplete += listDataRes[i].view_tdv_total_doc_complete_aggregate.aggregate.count;
              // let confirmed = this.listData[i].view_tdv_total_doc_confirmed_aggregate.aggregate.count;
              // let noScan = this.listData[i].view_tdv_total_doc_waiting_no_scan_aggregate.aggregate.count;
              // let normalKT = this.listData[i].view_tdv_total_doc_normal_kt_aggregate.aggregate.count;
              // let normalNY = this.listData[i].view_tdv_total_doc_normal_ny_aggregate.aggregate.count;
              // let normalNT3 = this.listData[i].view_tdv_total_doc_normal_tt_gn_nt3_aggregate.aggregate.count;
              // let normalT3 = this.listData[i].view_tdv_total_doc_type3_aggregate.aggregate.count;
              // let normalT4 = this.listData[i].view_tdv_total_doc_type4_aggregate.aggregate.count;
              // let normalT5 = this.listData[i].view_tdv_total_doc_type5_aggregate.aggregate.count;
              // this.totalRemain += confirmed - (noScan + normalKT + normalNY + normalNT3 + normalT3 + normalT4 + normalT5)
              this.totalRemain += listDataRes[i].view_tdv_total_doc_remaining_aggregate.aggregate.count;
            }
          }
          // this.totalDoc = this.listData.length;
          this.listData = list_data;
          this.dataModel.processData(this.listData)
          this.$store.commit('setLoading', false);
        }
      }).catch((error) => {
        this.$store.commit('setLoading', false);
        if (error.graphQLErrors && error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error)
      })
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel('statement_detail');
      // console.log(this.dataModel)
      this.title = this.dataModel.label;
    },
    async onEnter() {
      if (this.filterDate !== null) {
        this.$store.commit('setLoading', true);
        let date1 = new Date(this.filterDate[0]).toISOString()
        this.dateFrom = moment(date1).utc(7).format('YYYY-MM-DDT00:00:00.0[Z]')
        let date2 = this.filterDate[1] !== null ? new Date(this.filterDate[1]).toISOString() : date1
        this.dateTo = moment(date2).utc(7).format('YYYY-MM-DDT23:59:59.0[Z]')
        await this.onCreated();
      }
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // actions.header = { name: 'add', icon: 'plus', path: `import-document/add`};
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        // buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-manager/view/`};
        buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-document/edit/`},
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async actionsClicked(key, action, data) {
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    deleteData() {
      this.showDeleteDialog = false
      var query = DataServices.deleteData(this.modelName)
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        }
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(res => {
        if (res.data.delete_document.affected_rows > 0) {
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        } else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
        this.$apollo.queries.listData.refresh()
      }).catch((error) => {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xóa dữ liệu gặp vấn đề', life: 3000 })
        console.error('ERROR: ', error)
      });
    },
    onExportReport() {
      console.log('Xuat report: ', this.selectedRows)
    },
    onExportExcel(e) {
      console.log('Xuat excel: ', this.selectedRows)
      this.$store.commit("setLoading", true);
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      if (files[0].name.split('.').pop() !== 'xlsx' && files[0].name.split('.').pop() !== 'XLSX') {
        this.$store.commit("setLoading", false);
        this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng nhập file có định dạng xlsx', life: 3000 })
        return
      }
      this.$store.commit("setLoading", false);
    },
    // GỘP HÀM
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm:ss DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          /*console.log("this.optionsthis.optionsthis.optionsthis.options:",row)
          console.log("this.optionsthis.optionsthis.optionsthis.col.keycol.keycol.key:",col.key)*/
          lists = this.options[col.key];
          /*console.log("listslistslistslists111:",lists);
          console.log("rowrowrowrowrowrowrow:",row);*/
        }
        //value = "testss"
        if (lists && lists.length) {
          /*console.log("listslists:",lists);*/
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      } 
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn ${this.getLabel(col).toLowerCase()}`;
      } else if (col.filter.type == "input") {
        return `Nhập ${this.getLabel(col).toLowerCase()}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    }
  },
  apollo: {
    // listData: {
    //   query() {
    //     this.modelName = this.$route.meta.model;
    //     return DataServices.getList(this.modelName);
    //   },
    //   variables: {
    //     where_key: {
    //       users_account: {
    //         role: {_eq: "tdv"},
    //         deleted: {_eq: false}
    //       }, 
    //       deleted: {_eq: false}
    //     }
    //   },
    //   update(data) {
    //     this.title = this.dataModel.label + ' '
    //     this.dataModel.processData(listData)
    //     this.$store.commit('setLoading', false);
    //     this.componentKey += 1
    //     if (Object.keys(data).length > 0) {
    //       var listData = data[this.dataModel.tableName]
    //       this.totalDoc = data.users.length;
    //       return data[this.dataModel.tableName]
    //     }
    //   },
    //   fetchPolicy: 'network-only',
    //   error() {
    //     this.$store.commit('setLoading', false);
    //   },
    //   skip() {
    //     return !this.modelName
    //   }
    // }
  }

}
</script>
<style lang="scss">
.p-calendar .p-datepicker { padding: 0px !important; min-width: 100% !important;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {
  border-right: 1px solid #d8dae2 !important;
  padding-left: 0.857rem !important;
  padding-right: 0.857rem !important;
  background: #fff !important;
}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {
  border: 1px solid #c8c8c8 !important;
}
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    .title-filter {
      margin-left: 24px;
    }
    .btn-enter-filter {
      background-color: #0A84FF !important;
      margin-left: 10px;
      padding: 6px 30px;
    }
  }
}
.box-selected-file {
  // padding: 10px; 
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
}
.box-selected-file span {
  padding: 7px 15px; 
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF; 
  border-radius: 3px; 
  cursor: pointer;
  font-size: 0.875rem;
  color: #ffffff;
  .btn-span {
    background: #0A84FF 0% 0% no-repeat padding-box !important;
    border: 1px solid #0A84FF;
  }
}
.box-export-report {
  position: relative; 
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
  span {
    padding: 7px 15px; 
    background: #0A84FF 0% 0% no-repeat padding-box;
    border: 1px solid #0A84FF; 
    border-radius: 3px; 
    cursor: pointer;
    font-size: 0.875rem;
    color: #ffffff;
  }
}
</style>